const highlights = [
  { icon: 'ri-home-2-line', label: 'Roof Replacement & Repair' },
  { icon: 'ri-sun-line', label: 'Solar Installation' },
  { icon: 'ri-drop-line', label: 'Gutter Systems & Screens' },
  { icon: 'ri-battery-2-charge-line', label: 'Battery Storage' },
  { icon: 'ri-building-2-line', label: 'Flat & Metal Roofing' },
  { icon: 'ri-window-line', label: 'Skylight Replacement' },
];

export default function AIAnswerBlock() {
  return (
    <section className="py-24 border-y border-[#eeede8]" style={{ background: '#f8f8f5' }}>
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-14 items-start">

          {/* Left — structured answer */}
          <div className="w-full lg:w-[58%]">
            <div className="flex items-start gap-5 mb-8">
              <div className="w-1 flex-shrink-0 rounded-full bg-[#d4af37]" style={{ height: '56px', marginTop: '4px' }}></div>
              <div>
                <span
                  className="text-[#d4af37] text-[10px] uppercase tracking-[4px] font-bold block mb-2"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  About Shadowfax
                </span>
                <h2
                  className="font-black text-[#0d1a27] leading-tight"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 'clamp(1.5rem, 2.5vw, 2rem)', letterSpacing: '-0.01em' }}
                >
                  What Does Shadowfax Roofing &amp; Solar Do?
                </h2>
              </div>
            </div>

            <div className="space-y-5 pl-6">
              <p
                className="text-[#555] text-[15px] leading-[1.9]"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                <strong className="text-[#0d1a27] font-semibold">Shadowfax Roofing &amp; Solar</strong> is a family-owned roofing and solar company based in <strong className="text-[#0d1a27] font-semibold">Campbell, CA</strong>, serving homeowners throughout the South Bay and greater Bay Area. The company provides residential roof replacement, roof repair, gutter replacement, gutter screens, skylight replacement, solar installation, battery storage systems, flat roofing (TPO/PVC), and metal roofing.
              </p>
              <p
                className="text-[#555] text-[15px] leading-[1.9]"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                Their process begins with a thorough inspection and honest assessment — no pressure, no unnecessary upsells. Clients receive a detailed project scope covering materials, methods, and timelines before any work begins. Every project is coordinated to minimize disruption and completed with precision craftsmanship.
              </p>
              <p
                className="text-[#555] text-[15px] leading-[1.9]"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                Homeowners benefit from improved property value, long-term roof performance, reduced energy costs through solar, and the confidence of working with a licensed, insured team that understands South Bay housing and climate conditions.
              </p>
            </div>
          </div>

          {/* Right — service card */}
          <div className="w-full lg:w-[42%]">
            <div className="bg-white rounded-lg p-8 border border-[#eeede8]">
              <h3
                className="text-[11px] font-bold text-[#0d1a27] uppercase tracking-[2.5px] mb-7"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                Services Offered
              </h3>
              <div className="grid grid-cols-2 gap-4 mb-8">
                {highlights.map((item, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div
                      className="w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0"
                      style={{ background: 'rgba(212,175,55,0.1)' }}
                    >
                      <i className={`${item.icon} text-[#d4af37] text-sm`}></i>
                    </div>
                    <span
                      className="text-[#444] text-xs leading-snug"
                      style={{ fontFamily: "'Inter', sans-serif" }}
                    >
                      {item.label}
                    </span>
                  </div>
                ))}
              </div>

              <div className="pt-6 border-t border-[#f0f0ec]">
                <div className="flex items-start gap-3">
                  <div
                    className="w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 mt-0.5"
                    style={{ background: 'rgba(13,26,39,0.05)' }}
                  >
                    <i className="ri-map-pin-2-line text-[#0d1a27] text-sm"></i>
                  </div>
                  <div>
                    <p className="text-[#0d1a27] font-bold text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                      Campbell, CA
                    </p>
                    <p className="text-[#999] text-xs mt-1 leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
                      2959 Winchester Blvd Ste 102a<br />
                      Serving the South Bay &amp; Bay Area
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
